/* eslint-disable react-hooks/exhaustive-deps */
"use client";
import React, { useEffect } from "react";
import AllProps from "./components/all-props";
import MostPopularSection from "@/components-shared/homepage/most-popular";
import Search from "@/components-shared/search";
import Container from "@/components-shared/container";
import Filters from "./components/Filters";
import AllPropsMap from "./components/all-props-map";
import { useSearchParams } from "next/navigation";
import normalSearchPic from "@/public/images/normal-search.jpg";
import mapSearchPic from "@/public/images/map.jpg";

import { Separator } from "@/components-shared/ui/separator";
import { useTranslations } from "next-intl";
import { cn } from "@/lib/utils";
import useSizes from "@/lib/window-sizes-hook";
import { ChevronLeftIcon, MapPin } from "lucide-react";
import { useDispatch, useSelector } from "react-redux";
import {
  clearSearchParams,
  getAllFromSearchParams,
} from "@/redux/slices/searchParams.slice";
import { RootState } from "@/redux/store";
import Image from "next/image";

const AllUnitsPage = () => {
  const t = useTranslations();
  const [mapView, setMapView] = React.useState(false);
  const dispatch = useDispatch();
  const { maxSm } = useSizes();
  const isClient = useSelector((state: RootState) => state.isBrowser);
  const searchParams = useSearchParams();

  useEffect(() => {
    const entries: Record<string, string | string[]> = {};
    searchParams.forEach((value, key) => {
      const values = searchParams.getAll(key);
      entries[key] = values.length > 1 ? values : value;
    });

    console.log(entries);

    dispatch(getAllFromSearchParams(entries));

    return () => {
      dispatch(clearSearchParams());
    };
  }, []);

  const SwitchButton = () => {
    if (maxSm && isClient) {
      return (
        <button
          className={cn(
            "rounded-2xl relative group flex overflow-hidden w-64 h-48 size-auto justify-center items-center"
          )}
          onClick={() => setMapView((prev) => !prev)}
          aria-label="switcher button"
        >
          <div
            className={cn(
              "bg-green-background z-10 group-hover:bg-green-50 transition flex-1 text-center underline underline-offset-2 text-green-main self-auto p-4 rounded-2xl flex px-4"
            )}
          >
            {mapView ? (
              <>
                {t("allUnitsPage.return")}
                <ChevronLeftIcon />
              </>
            ) : (
              <MapPin className="mx-auto" />
            )}
          </div>
        </button>
      );
    }

    return (
      <button
        className={cn(
          "rounded-2xl relative group flex overflow-hidden w-64 h-48"
        )}
        onClick={() => setMapView((prev) => !prev)}
        aria-label="switcher button"
      >
        {mapView ? (
          <Image
            className="absolute top-0 left-0"
            src={normalSearchPic}
            alt={"normal search pic"}
          />
        ) : (
          <Image
            className="absolute top-0 left-0"
            src={mapSearchPic}
            alt="map search pic"
          />
        )}
        <div
          className={cn(
            "bg-green-background z-10 group-hover:bg-green-50 transition self-end flex-1 text-center py-4 underline underline-offset-2 text-green-main"
          )}
        >
          {mapView ? t("allUnitsPage.normalView") : t("allUnitsPage.mapSearch")}
        </div>
      </button>
    );
  };

  return (
    <>
      <Container
        className={cn("flex gap-3 sm:gap-8 items-center mt-10", {
          "justify-end": mapView && maxSm && isClient,
        })}
      >
        <SearchWithSearchParams ismap={mapView} />

        <SwitchButton />
      </Container>

      <main className="grid grid-cols-18 mt-8">
        <aside className="col-span-4 max-sm:hidden relative px-3 lg:px-7">
          <Filters />
        </aside>
        <section className="col-span-14 max-sm:col-span-full px-5 md:px-7 lg:px-10">
          {mapView ? <AllPropsMap /> : <AllProps />}
        </section>
      </main>
      <Separator className="max-w-3xl mx-auto my-12" />

      <MostPopularSection className="mb-5" />
    </>
  );
};

export default AllUnitsPage;

const SearchWithSearchParams = ({ ismap }: { ismap?: boolean }) => {
  return <Search {...{ ismap }} noSearchBtn />;
};
